import * as types from "./actions";

const defaultState = {
    list: [],
    tableHeader:[
        {
            label: "ユーザ名", 
            button:false
        },
        {
            label: "編集",
            button:true
        },
    ],
    tableColumns:[
        "userName"
    ],
    form:[
        {
            type: "text",
            label: "ユーザ名",
            placeholder: "",
            name: "userName",
            maxLength: 40,
            required: true,
            disabled: false
        },
        {
            type: "text",
            label: "ログインID",
            placeholder: "",
            minLength: 8,
            maxLength: 16,
            name: "loginId",
            required: true,
            disabled: false,
        },
        {
            type: "text",
            label: "パスワード",
            placeholder: "",
            minLength: 8,
            maxLength: 16,
            name: "password",
            required: true,
            disabled: false
        }
    ],
}

export default function reducer (state=defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return {...state, list: action.payload};
        default: // need this for default case
            return state 
    }
};
